export { default } from "./indexedSection";
